import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";


const AdvantagesSection = ({ title = "", advantages = [], countryName = "Germany" }) => {

  useEffect(() => {
    const selectedId = localStorage.getItem("selectedAdvantageId");

    if (selectedId !== null && advantages.length > 0) {
      requestAnimationFrame(() => {
        const element = document.getElementById(
          `advantage-card-${selectedId}`
        );

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }

        localStorage.removeItem("selectedAdvantageId");
      });
    }
  }, [advantages]);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const getResponsiveTitle = (html) => {
    if (!html) return "";

    let clean = html
      // .replace(/style="[^"]*"/gi, "") // ✅ REMOVE ALL inline styles
      .replace(
        /<(?!ol\b|ul\b)([a-z][a-z0-9]*)\b([^>]*)\sstyle="[^"]*"([^>]*)>/gi,
        "<$1$2$3>"
      )
      .replace(/&nbsp;/gi, "")
      .replace(/<br\s*\/?>/gi, "");

    if (!isMobile) return clean;

    return clean
      .replace(/font-weight:\s*900/gi, "font-weight: 700");
  };

  const normalizeUrl = (url) => {
    if (!url) return null;

    let normalized = url.trim();

    // If no protocol, add https://
    if (!/^https?:\/\//i.test(normalized)) {
      normalized = "https://" + normalized;
    }

    return normalized;
  };

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <Container sx={{
      py: { xs: 2, sm: 2, md: 3 },
      px: { xs: 3, sm: 4, md: 6 },
      paddingLeft: { xs: "24px !important", md: "48px !important" },
      paddingRight: { xs: "24px !important", md: "48px !important" }
    }}>
      {/* 🔹 Heading */}
      <Box mb={2}>
        <Box
          sx={{
            display: "inline-block",
            position: "relative",
            mb: 2,

            "&::after": {
              content: '""',
              position: "absolute",
              left: 0,
              bottom: -5,
              width: "200px",
              height: "2px",
              backgroundColor: "#fd0000",
              opacity: "0.5"
            },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "22px", sm: "26px", md: "30px" },
            }}
            dangerouslySetInnerHTML={{ __html: getResponsiveTitle(title) }}
          />

        </Box>
      </Box>

      {/* 🔹 Advantages List */}
      <Grid

        component={motion.div}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        container spacing={3}>
        {advantages.map((advantage, index) => (
          <Grid
            id={`advantage-card-${index}`}
            component={motion.div}
            variants={cardVariants}
            whileHover={{ y: -8 }}
            size={{ xs: 12, sm: 6, md: 4, }}
            key={index}
          >
            <Card
              onClick={() => {
                localStorage.setItem("selectedAdvantageId", index);
                navigate(`/offer/${advantage.title}`);
              }}
              sx={{
                height: "100%",
                backgroundColor: "#002045",
                borderRadius: "16px",
                boxShadow: "none",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                textAlign: 'center',
                // cursor: (advantage.url == null || advantage.url == undefined || advantage.url == "") ? "default" : "pointer",
                "&:hover": {
                  boxShadow: "0px 10px 25px rgba(0,0,0,0.25)"
                }
              }}
            >
              <CardContent sx={{
                "&:last-child": {
                  pb: 2,
                },
              }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: '"Nunito Sans", sans-serif',
                    fontWeight: 800,
                    fontSize: { xs: "14px", sm: "16px" },
                    lineHeight: "28px",
                    color: "#ffffff",
                    textTransform: "capitalize",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  {advantage.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AdvantagesSection;
